import { render, staticRenderFns } from "./customersComponent.vue?vue&type=template&id=20a1ea18&scoped=true"
import script from "./customersComponent.vue?vue&type=script&lang=js"
export * from "./customersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1ea18",
  null
  
)

export default component.exports